export default {
  cost_one: '{{count}} point',
  cost_other: '{{count}} points',
  discount: '{{count}}% off',
  available: 'Reward unlocked 🎉',
  unavailable_one: '{{count}} point to go',
  unavailable_other: '{{count}} points to go',
  download_app: '➡️ Follow the steps described in the SMS to redeem your reward',
};
